/* @flow weak */
import PropTypes from 'prop-types';
import * as React from 'react';

import AuthActions from 'auth/AuthActions';
import BoxBody from 'components/BoxBody';
import BoxFooter from 'components/BoxFooter';
import Button from 'components/ButtonDeprecated';
import CurrentUser from 'auth/CurrentUser';
import DialogContent from 'components/DialogContent';
import EventTracking from 'lib/EventTracking';
import FormDeprecated from 'components/FormDeprecated';
import FormInput from 'components/FormInput';
import humanparser from 'humanparser';
import ToastActions from 'actions/ToastActions';
import TosText from 'components/TosText';
import UserActions from 'user/UserActions';
import ConfirmDevice from 'auth/components/ConfirmDevice';

class JoinEmailAccountUpgradeForm extends React.Component<$FlowFixMeProps, $FlowFixMeState> {
  static propTypes = {
    onDone: PropTypes.func.isRequired,
  };

  state = {
    enabled: false,
    needsDeviceConfirmation: false,
    needsConfirmationErrorCode: '',
  };

  handleSubmit = attrs => {
    const onFailure = (error: any) => {
      if (error.statusCode === 403) {
        this.setState({ needsDeviceConfirmation: true, needsConfirmationErrorCode: error.code });
      } else {
        ToastActions.showDefaultErrorToast();
      }
    };

    const onUpdateSuccess = () => {
      AuthActions.signIn(CurrentUser.getUser().getEmail(), attrs.password).then(
        this.props.onDone,
        onFailure
      );

      EventTracking.trackKey('tos_and_pp.view');
    };

    const human = humanparser.parseName(attrs.full_name);

    UserActions.update({
      prefix: human.salutation,
      first_name: human.firstName,
      last_name: human.lastName,
      password: attrs.password,
    }).then(onUpdateSuccess, onFailure);
  };

  render() {
    const { needsDeviceConfirmation } = this.state;

    if (needsDeviceConfirmation) {
      const { needsConfirmationErrorCode } = this.state;

      return (
        <DialogContent size="small">
          <BoxBody divided>
            <ConfirmDevice
              deviceType="email"
              uid={CurrentUser.getUser().getEmail()}
              // At this point, a password should have been set already
              needsPassword={false}
              needsConfirmationErrorCode={needsConfirmationErrorCode}
              onConfirmationDone={this.props.onDone}
              onGoBack={undefined}
            />
          </BoxBody>
          <BoxFooter>
            <TosText />
          </BoxFooter>
        </DialogContent>
      );
    } else {
      return (
        <DialogContent size="small" title="Complete your account">
          <BoxBody divided>
            <FormDeprecated
              onSubmit={this.handleSubmit}
              onValid={() => this.setState({ enabled: true })}
              onInvalid={() => this.setState({ enabled: false })}>
              <FormInput
                label="Full name"
                type="text"
                size="large"
                name="full_name"
                placeholder="First and last name"
                validations="minLength:3"
                showErrorAfterBlur
                validationErrors={{
                  minLength: 'Names should be at least 3 characters long.',
                }}
              />
              <FormInput
                label="Choose a password"
                type="password"
                autoComplete="new-password"
                className="UserPasswordForm-password"
                name="password"
                validations="minLength:6"
                validOnPristine
                validationError="Password must be at least 6 characters long."
              />
              <Button disabled={!this.state.enabled}>Submit</Button>
            </FormDeprecated>
          </BoxBody>
          <BoxFooter>
            <TosText />
          </BoxFooter>
        </DialogContent>
      );
    }
  }
}

export default JoinEmailAccountUpgradeForm;
